export type Platform = 'android' | 'ios' | 'mac' | 'other';

export function detectPlatform(userAgent: string = navigator.userAgent): Platform {
    if (/android/i.test(userAgent)) return 'android';
    if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
    if (/macintosh|mac os x/i.test(userAgent)) return 'mac';
    return 'other';
}
